// Persian-inspired color palette and design constants for Hokm

export const PERSIAN_THEME = {
  colors: {
    // Backgrounds
    feltGreen: 0x1a4a3a,
    tableCenter: 0x0f3a2a,
    darkOverlay: 0x0d1f12,

    // Accents
    gold: 0xd4af37,
    bronze: 0x8b7355,
    jade: 0x2d5a47,

    // Team colors (4P mode) - Gold: South+North, Teal: West+East
    teamA: 0xc9a227, // Gold team
    teamB: 0x4a90a4, // Teal team

    // Individual player colors (2P/3P mode)
    player1: 0x4ecdc4, // Teal
    player2: 0xff6b6b, // Coral red
    player3: 0xc77dff, // Bright purple

    // Text
    textPrimary: 0xf4e8d3,
    textSecondary: 0xb8a88a,
    textHighlight: 0xffd700,

    // UI elements
    buttonBg: 0x2d5a47,
    buttonHover: 0x3d6a57,
    buttonBorder: 0x8b7355,
    inputBorder: 0x8b7355,

    // Card back
    cardBack: 0x1a3a5c,
    cardBackPattern: 0x2d5a7c,
  },

  // Hex string versions for CSS and Phaser text
  hex: {
    feltGreen: '#1a4a3a',
    tableCenter: '#0f3a2a',
    gold: '#d4af37',
    bronze: '#8b7355',
    jade: '#2d5a47',
    teamA: '#c9a227',
    teamB: '#4a90a4',
    player1: '#4ecdc4',
    player2: '#ff6b6b',
    player3: '#c77dff',
    textPrimary: '#f4e8d3',
    textSecondary: '#b8a88a',
    textHighlight: '#ffd700',
    buttonBg: '#2d5a47',
    buttonHover: '#3d6a57',
    cardBack: '#1a3a5c',
  },

  // Farsi text
  farsi: {
    hokm: 'حکم', // Hokm (Trump/Rule)
    hakem: 'حاکم', // Hâkem (Ruler/Trump maker)
    kot: 'کُت', // Kot (Sweep)
    hakemKoti: 'حاکم کُتی', // Hâkem Koti (Hâkem loses all 13)
    bazi: 'بازی', // Game
    dast: 'دست', // Hand/Round
    rules: 'قوانین بازی', // Game rules
    south: 'جنوب',
    north: 'شمال',
    east: 'شرق',
    west: 'غرب',
    hearts: 'دل',
    diamonds: 'خشت',
    clubs: 'گشنیز',
    spades: 'پیک',
  },

  // Font settings
  fonts: {
    title: 'Georgia, "Times New Roman", serif',
    body: 'Arial, sans-serif',
    farsi: 'Vazirmatn, Tahoma, sans-serif',
  },

  // Team display names (internal: A/B, display: Gold/Teal)
  teamNames: {
    A: 'Gold',
    B: 'Teal',
  },
} as const;

export type PersianTheme = typeof PERSIAN_THEME;
